import tmhRequest from '@/config/tmhRequest'

export default {

    searchListServiceTopical: function (data) {
        return tmhRequest({
            url: '/project/tmh/servicetopical/searchlistservicetopical',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/servicetopical.js